import React, { useState, useEffect } from "react";
import { MenuOutlined, CloseOutlined, HeartFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledHeader = styled.div`
  transition: all 0.5 ease-in;
  z-index: 2000;
  background: transparent;
  position: relative;
  @media (max-width: 768px) {
    height: 123px;
  }
  .drop {
    z-index: 20000;
  }
  .nav-content {
    height: 123px;
    padding: 0 30px;
    /* background: ${(props) =>
      props.background ? props.background : "transparent"}; */
    display: grid;
    place-items: center;
    z-index: 20000;
    @media (max-width: 768px) {
      display: none;
    }
  }
  nav span small {
    padding: 30px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    font-family: "Oswald", sans-serif;
    letter-spacing: 1.4px;
    color: #000;
  }
  .navPos {
    position: fixed;
    top: 0;
    height: 140px;
    width: 100%;
    background: #fff;
    color: black;
    transition: all 0.5s ease-in-out;
    font-family: "Oswald", sans-serif;
    font-weight: 500;
  }
  .navPos a {
    color: #000;
    font-family: "Oswald", sans-serif;
    font-weight: bold;
  }

  .circle {
    height: 60px;
    width: 60px;
    border-radius: 100%;
    background: #f039ad;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
    color: #fff;
    text-transform: uppercase;
    font-family: "Oswald", sans-serif;
    @media (max-width: 768px) {
      position: relative;
      top: 25px;
      left: 20px;
      padding: 20px 20px;
      font-size: 150%;
      text-transform: uppercase;
      height: 65px;
      width: 65px;
    }
  }

  .anticon {
    padding: 2px;
    font-size: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .toggle {
    position: absolute;
    top: 25px;
    right: 10px;
    padding: 20px 15px;
  }

  .hide-desktop {
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
  .icon-style {
    font-size: 42px;
    font-weight: 900;
    color: #000;
    transition: all 0.5s ease-out;
  }
  .dropbtn {
    padding: 16px;
    font-size: 16px;
    border: none;
  }

  /* The container <div> - needed to position the dropdown content */
  .dropdown {
    position: relative;
    display: inline-block;
  }

  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    top: 40px;
    position: absolute;
    border: 1px solid pink;
    background-color: #fff;
    min-width: 170px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  /* Links inside the dropdown */
  .dropdown-content a {
    color: black;
    padding: 15px 17px;
    text-decoration: none;
    display: block;
    text-transform: uppercase;
    font-weight: 600;
  }

  /* Change color of dropdown links on hover */
  .dropdown-content a:hover {
    background-color: #ddd;
  }

  /* Show the dropdown menu on hover */
  .dropdown:hover .dropdown-content {
    display: block;
  }
`;
const MobileSubMenu = styled.div`
  background: #000000;
  transition: all 0.5 ease-in;
  text-transform: uppercase;
  font-family: "Oswald", sans-serif;
  letter-spacing: 1.4px;
  display: none;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: #fff;
  position: absolute;
  top: 90px;
  right: 0;
  z-index: 999;
  border-radius: 0px 0px 0px 25px;
  transform: scale(1.01);
  @media (max-width: 768px) {
    padding-right: 3%;
    width: 90%;
    min-height: 240px;
    opacity: 0.7;
    top: 160px;
    left: 20px;
    display: block;
  }

  .mobile-menu-dropdown-item {
    width: 100%;
    /* display: none; */
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 25px;
    color: #fff;
    transition: all 0.4s ease-in;
    border-bottom: 1.5px solid rgba(255, 255, 255, 0.05);
    transition: max-height 400ms ease-in-out;
    @media (max-width: 768px) {
      height: 50px;
      padding: 16px;
    }
  }
  .mobile-menu-dropdown-item a {
    color: #fff;
    transition: all 0.4s ease-in;
  }
  .mobile-menu-dropdown-item.mobile-only {
    display: none;
    @media (max-width: 768px) {
      display: flex;
      transition: max-height 400ms ease-in-out;
    }
  }
`;

function Header({ menuOpen, toggleMenu }) {
  const [, setColor] = useState("transparent");
  const [scrolled, setScrolled] = useState(false);

  const changeScrolled = () => {
    const scrollPosition = document.documentElement.scrollTop;
    setScrolled(scrollPosition > 280 ? true : false);
  };

  useEffect(() => {
    window.addEventListener("scroll", changeScrolled);
    return () => {
      window.addEventListener("scroll", changeScrolled);
    };
  }, []);

  const [drop, setDrop] = useState(true);
  const handleDrop = () => {
    setDrop(!drop);
  };
  return (
    <>
      <StyledHeader>
        <div className={scrolled ? "navPos" : null}>
          <div className="nav-content">
            <nav className="">
              <span>
                <Link to="/" onClick={() => setColor("transparent")}>
                  <span>
                    <small>home</small>
                  </span>
                </Link>
              </span>
              <span onClick={() => setColor("#fff")}>
                <span class="dropdown">
                  <small class="dropbtn"> about</small>
                  <span class="dropdown-content">
                    <Link to="/about-her">About Her</Link>
                    <Link to="/about-him">About Him</Link>
                  </span>
                </span>
              </span>
              <span>
                <Link to="/gallery" onClick={() => setColor("#fff")}>
                  <span>
                    <small>gallery</small>
                  </span>
                </Link>
              </span>
              <Link to="/" onClick={() => setColor("transparent")}>
                <span className="circle">
                  g<HeartFilled />d
                </span>
              </Link>
              <span>
                <Link to="/story" onClick={() => setColor("#fff")}>
                  <span>
                    <small>the story</small>
                  </span>
                </Link>
              </span>

              <span class="dropdown" onClick={handleDrop}>
                <small class="dropbtn"> the wedding</small>
                <span class="dropdown-content">
                  <Link to="/location" onClick={handleDrop}>
                    Location
                  </Link>
                  <Link to="/accomodation">Accomodation</Link>
                  <Link to="/gift-registry">Gift Registry</Link>
                  <Link to="/bride-maids">Bridesmaids</Link>
                  <Link to="/grooms-men">Groomsmen</Link>
                </span>
              </span>
              <span>
                <Link to="/rsvp-page" onClick={() => setColor("#fff")}>
                  <span>
                    <small>rsvp </small>
                  </span>
                </Link>
              </span>
            </nav>
          </div>

          <div className="toggle">
            <div className="hide-desktop" onClick={toggleMenu}>
              {!menuOpen ? (
                <MenuOutlined className="icon-style" />
              ) : (
                <CloseOutlined className="icon-style" />
              )}
            </div>
          </div>
          <div className="menu">
            <div className="hide-desktop">
              <Link to="/">
                <span className="circle">
                  g<HeartFilled />d
                </span>
              </Link>
            </div>
            {menuOpen && (
              <MobileSubMenu>
                <div className="mobile-menu-dropdown-item">
                  <span>
                    <Link to="/">
                      <span>Home</span>
                    </Link>
                  </span>
                </div>
                <div className="mobile-menu-dropdown-item alt-bg">
                  <span>
                    <Link to="/about">
                      <span>About</span>
                    </Link>
                  </span>
                </div>
                <div className="mobile-menu-dropdown-item">
                  <span>
                    <Link to="/gallery">
                      <span>Gallery</span>
                    </Link>
                  </span>
                </div>
                <div className="mobile-menu-dropdown-item ">
                  <span>
                    <Link to="/story">
                      <span>Story</span>
                    </Link>
                  </span>
                </div>
                <div className="mobile-menu-dropdown-item alt-bg">
                  <span>
                    <Link to="/location">
                      <span>Wedding</span>
                    </Link>
                  </span>
                </div>
                <div className="mobile-menu-dropdown-item alt-bg">
                  <span>
                    <Link to="/rsvp-page">
                      <span>Rsvp</span>
                    </Link>
                  </span>
                </div>
              </MobileSubMenu>
            )}
          </div>
        </div>
      </StyledHeader>
    </>
  );
}

export default Header;
